module.exports = __webpack_public_path__ + "img/fail.e9d0ee72.svg";